export const customToolBarStyles = (theme) => ({
    toolBarRoot: {
        paddingRight: theme.spacing(1),
        backgroundColor: '#002d5b'
    },
    palette: {
        primary: '#607d8b',
        secondary: {
            main: '#90a4ae'
        }
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                  color: '#002D5B'
              }
            : {
                  color: theme.palette.text.primary,
                  backgroundColor: theme.palette.secondary.dark
              },
    spacer: {
        flex: '1 1 70%'
    },
    actions: {
        color: theme.palette.text.secondary
    },
    toolBartitle: {
        flex: '0 0 auto'
    },
    root: {
        width: '100%'
    },
    grow: {
        flexGrow: 1
    },
    iconButton: {
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0)'
        }
    },
    iconButtonRoot: {
        padding: 12,
        color: '#000000',
        opacity: 0.5,
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0)'
        }
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block'
        },
        color: '#ffffff !important'
    },
    inputRoot: {
        color: 'black',
        width: '90%'
    },
    customPad: {
        fontSize: '1.1rem',
        fontWeight: 600
    },
    inputInput: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(10),
        transition: theme.transitions.create('width'),
        width: '100%',

        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200
            }
        }
    },
    iconAlign: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    buttonCustomPad: {
        paddingRight: 0
    },
    createBtn: {
        fontSize: '14px !important'
    },
    titleTextRoot: {
        display: 'flex',
        alignItems: 'center'
    },
    titleText: {
        fontSize: '1.3rem !important',
        fontWeight: 500,
        color: '#ffffff !important',
        marginLeft: 2
    },
    closeIcon: { fontSize: '14px', cursor: 'pointer' }
});
